import { render, staticRenderFns } from "./NewAuth.vue?vue&type=template&id=4566686f&"
import script from "./NewAuth.vue?vue&type=script&lang=js&"
export * from "./NewAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports